
import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent } from '@components/core/panel/panel.component';
import { EntityService } from '@services/core/entity.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
	selector: 'app-edit-group',
	templateUrl: './edit_group.component.html',
	styleUrls: ["./edit_group.component.css"],
    imports: [PanelComponent, ReactiveFormsModule],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: true,
})
export class EditGroupComponent implements OnInit{
    @Input() group: any
    @Output() close = new EventEmitter()
    @Output() update = new EventEmitter()
    private entityService = inject(EntityService)
	private _fb = inject(FormBuilder)
    private destroyRef = inject(DestroyRef)
    public groupForm: FormGroup 
    protected groups
    protected offices

	ngOnInit(): void {
        this.groupForm = this._fb.group({
            id: [null],
            name: [null, [Validators.required]],
            acronym: [null, [Validators.required]],
            enabled: [true]
        })
        if(this.group) this.setForm()
	}

    setForm(){
        this.groupForm.patchValue({
            id: this.group.id,
            name: this.group.name,
            acronym: this.group.acronym,
            enabled: this.group.enabled
        })
    }

    save(){
        this.entityService.updateGroup(this.groupForm.value).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            this.update.emit()
        })
    }

    cancel(){
        this.close.emit()
    }
  
}
